import styled, { css } from 'styled-components';

import { styledReset, styledTypography } from '@pkg/primitives';

export const TEXT_STYLES = css`
    ${styledTypography.allianceBase};
    line-height: 1.3;
`;

export const StyledP = styled.p`
    ${TEXT_STYLES};
    color: 1px solid ${({ theme }) => theme.shades.white[40]};
    margin: 6px 0;
    font-size: 17px;
`;

///
/// Headings

export const HEADER_STYLES = css`
    font-weight: 700;
    margin: 8px 0;
`;

export const StyledH1 = styled.h1`
    ${TEXT_STYLES};
    ${HEADER_STYLES};
`;

export const StyledH2 = styled.h2`
    ${TEXT_STYLES};
    ${HEADER_STYLES};
`;

export const StyledH3 = styled.h3`
    ${TEXT_STYLES};
    ${HEADER_STYLES};
`;
export const StyledH4 = styled.h4`
    ${TEXT_STYLES};
    ${HEADER_STYLES};
`;

export const StyledH5 = styled.h5`
    ${TEXT_STYLES};
    ${HEADER_STYLES};
`;

export const StyledH6 = styled.h6`
    ${TEXT_STYLES};
    ${HEADER_STYLES};
`;

///
/// Lists

export const LIST_STYLES = css`
    ${TEXT_STYLES};
    margin: 12px 0;
    padding: 0 0 0 30px;
`;

export const StyledOL = styled.ol`
    ${LIST_STYLES};
`;

export const StyledUL = styled.ul`
    ${LIST_STYLES};
`;

export const StyledLi = styled.li`
    ${TEXT_STYLES};
    padding: 0 0 0 4px;
`;

///
/// Others

export const StyledLink = styled.a.attrs({
    rel: 'noopener noreferrer',
})`
    ${styledReset.link};
    ${TEXT_STYLES}
    font-weight: 600;
    color: ${({ theme }) => theme.shades.white[80]};

    &:hover {
        color: ${({ theme }) => theme.shades.white[100]};
    }
`;

export const StyledBlockQuote = styled.blockquote`
    background: ${({ theme }) => theme.shades.white[5]};
    border-left: 1px solid ${({ theme }) => theme.shades.white[10]};
    padding: 4px 8px;

    &::before {
        color: ${({ theme }) => theme.shades.white[15]};
        content: open-quote;
        position: absolute;
        font-size: 70px;
    }

    p {
        font-style: oblique;
        margin-left: 6px;
    }
`;

export const StyledImage = styled.img`
    display: flex;
    object-fit: contain;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    max-width: 2000px;
`;
